var map = {
	"./cock.jpg": 618,
	"./cock10.jpg": 877,
	"./cock11.jpg": 245,
	"./cock13.jpg": 8,
	"./cock15.jpg": 986,
	"./cock17.jpg": 789,
	"./cock2.jpg": 122,
	"./cock3.jpg": 991,
	"./cock4.jpg": 54,
	"./cock8.jpg": 263,
	"./cock9.jpg": 119,
	"./paper.jpg": 676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274;